import { Formik } from 'formik';
import * as Yup from 'yup';
import FormikTextField from 'Components/Form/FormikTextField';
import { Button, Row } from 'react-bootstrap';
import BSButton from 'Components/Button/BSButton';
import {
  integratonFieldsToObject,
  integrationFieldsToSchema,
} from 'helpers/form';
import Link from '../../../Components/Input/Link/Link';

const IntegrationForm = ({ type, fields, defaultValues, onSubmit }) => {
  const initialValues = integratonFieldsToObject(fields, defaultValues);
  const dynamicSchema = integrationFieldsToSchema(fields, defaultValues);

  const validationSchema = Yup.object(dynamicSchema);

  const handleSubmit = (values) => {
    onSubmit(type.toLowerCase(), values);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount={true}
      enableReinitialize={true}
    >
      {({ values, isValid }) => {
        return (
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column gap-3"
          >
            <Row className="g-3">
              {fields?.map((field) => {
                const fieldKey = field.field;
                const isFieldOptional =
                  validationSchema.describe().fields[fieldKey].optional;

                return (
                  <FormikTextField
                    Label={field.description}
                    isRequired={!isFieldOptional}
                    key={fieldKey}
                    name={fieldKey.toLowerCase()}
                    type="text"
                    placeholder={field.description}
                    classList="input"
                  />
                );
              })}
            </Row>

            <div className="d-flex justify-content-between align-items-center">
              <Button
                variant="outline-dark"
                href="https://blog.vocable.ai/publishing-integration-instructions"
              >
                Watch Tutorial
              </Button>

              <Button
                variant={!isValid ? 'secondary' : 'dark'}
                disabled={!isValid}
                onClick={() => handleSubmit(values)}
              >
                Submit
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default IntegrationForm;